import React from 'react';

export const Hero = () => (
  <>
    <h1 className="text-4xl md:text-5xl text-[#373945] font-semibold mt-6 mb-4">
      Calculators
    </h1>

    <p className="text-base text-[#373945] font-medium">
      Try our lifetime mortgages calculators where you can calculate optional partial repayments, annual overpayments,
      and interest servicing.
    </p>
  </>
);
